// In production (Vercel), we use relative URLs to leverage the proxy
// In development, we use the full URL from environment variables
const BASE_URL = process.env.NODE_ENV === 'production'
  ? '/vendor/'
  : process.env.REACT_APP_BASE_URL;
export { BASE_URL };

console.log("Backend URL:", BASE_URL);
const getHeaders = () => {
    const getToken = () => {
        const auth_token = localStorage.getItem('authToken');
        // console.log('showing token...')
        // console.log(auth_token);
        return 'Bearer '+ auth_token;
    };
    return {
        'Content-Type': 'application/json',
        'Authorization': getToken(),
    };
};

// ApiMethods class provides static methods for API operations

class ApiMethods {
    static handleUnauthorized = () => {
        localStorage.removeItem("authToken");
        // window.location.href = "/"; // Removed to allow React Router to handle navigation and error display
    };

    static getAuthHeader = () => {
        const auth_token = localStorage.getItem('authToken');
        return 'Bearer ' + auth_token;
    };

    static fetchWithAuth = (url, options = {}) => {
        url = BASE_URL + url;

        return new Promise((resolve, reject) => {
            fetch(url, options)
                .then(response => {
                    if (response.status === 401) {
                        this.handleUnauthorized();
                        reject('Unauthorized: 401');
                    } else {
                        resolve(response);
                    }
                })
                .catch(error => reject(error));
        });
    };

    static apiRequests = (method, url, body = {}) => {
        url = BASE_URL + url;
        const options = {
            method,
            headers: getHeaders(),
        };
        if (['POST', 'PUT', 'DELETE'].includes(method)) {
            options.body = JSON.stringify(body);
        }
        return new Promise((resolve, reject) => {
            fetch(url, options)
                .then(response => {
                    if (response.status === 401) {
                        this.handleUnauthorized();
                        reject('Unauthorized: 401');
                    } else {
                        resolve(response);
                    }
                })
                .catch(error => reject(error));
        });
    };

    static get(url) {
        return this.apiRequests('GET', url);
    }

    static post(url, data) {
        return this.apiRequests('POST', url, data);
    }

    static put(url, data) {
        return this.apiRequests('PUT', url, data);
    }

    static delete(url) {
        return this.apiRequests('DELETE', url);
    }

    // Method removed - use fetchWithAuth instead

    static downloadExcel(url) {
        url = BASE_URL + url;

        const headers = {
            Authorization: getHeaders().Authorization,
            "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        };

        const options = {
            method: "GET",
            headers,
        };

        return new Promise((resolve, reject) => {
            fetch(url, options)
                .then(response => {
                    if (response.status === 401) {
                        this.handleUnauthorized();
                        reject("Unauthorized: 401");
                    } else {
                        resolve(response);
                    }
                })
                .catch(error => reject(error));
        });
    }
}

export default ApiMethods;